module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge_desktop.bef54c3c.jpg";